import { t } from 'utils/i18n';
import * as Sentry from '@sentry/react';
import { errorStore, userStore } from 'stores';

const errorMessages = {
  500: 'serverError',
  502: 'serverError',
  503: 'serverError',
  504: 'serverError',
};

export const handleServiceError = (e) => {
  if (e.status >= 500 || e.status === 400 || e.status === false) {
    Sentry.withScope((scope) => {
      scope.setExtra('status', e.status);
      scope.setExtra('errorInfo', e.errors);
      scope.setExtra('message', e.message);
      const { user } = userStore;
      if (user?.uname ?? user?.username) {
        scope.setUser({ username: user.uname ?? user.username });
      }
      Sentry.captureException(e);
    });
  }
  if (e.errors?.baseErrors?.message) {
    errorStore.setError(e.errors.baseErrors?.message);
  }
};

export const handleSentryDataError = (e) => {
  Sentry.withScope((scope) => {
    scope.setExtra('errorInfo', e.message);
    const { user } = userStore;
    if (user?.uname ?? user?.username) {
      scope.setUser({ username: user.uname ?? user.username });
    }
    Sentry.captureException(e);
  });
  return { baseErrors: { message: t('unrecoverableErrorOccured') } };
};

export const getError = (error) => {
  if (Array.isArray(error)) {
    return error.join(' ');
  }
  if (typeof error === 'object') {
    let errObject = {};
    Object.keys(error).forEach((objField) => {
      errObject = { ...errObject, [objField]: error[objField].join(' ') };
    });
    return errObject;
  }
  return error;
};

export const getSentryErrorObject = (error) => {
  const errors = error.response?.data?.error?.errors;
  if (!errors || errors.length === 0) {
    const errorMessage = error.response?.data?.error?.message || error.message;
    const userErrorMessage = error.response?.status
      ? t(errorMessages[error.response?.status])
      : t('fetchTimeoutError');
    const sentryErrorObj = {
      message: errorMessage,
      reason: errorMessage,
      validationErrors: {},
      baseErrors: { message: userErrorMessage || errorMessage },
    };
    return sentryErrorObj;
  }
  if (!errors[0]?.reason) {
    return t('serverDown');
  }

  let messageText = '';
  let reasonText = '';
  let validationErrors = {};
  let baseErrors = {};
  errors.forEach((errorItem) => {
    const { message, reason } = errorItem;
    if (typeof message === 'object') {
      Object.keys(message).forEach((field) => {
        messageText = `${messageText} ${field} : ${getError(message[field])}`;
      });
    } else {
      messageText = `${messageText} ${message}`;
    }
    reasonText = `${reasonText} ${reason}`;

    if (errorItem.reason === 'ValidationError') {
      Object.keys(message).forEach((field) => {
        validationErrors = {
          ...validationErrors,
          [field]: getError(message[field]),
        };
      });
    }
    if (errorItem.reason === 'BaseError') {
      baseErrors = typeof message === 'object' ? message : { message };
    }
    if (errorItem.reason === 'ObjectDoesNotExist') {
      baseErrors = { message };
    }
    if (errorItem.reason === 'IndexError') {
      baseErrors = { message };
    }
  });
  return {
    message: messageText,
    reason: reasonText,
    validationErrors,
    baseErrors,
  };
};

export const logError = (message) => {
  handleSentryDataError(new Error(message));
};
